import React from 'react';
import { FormState } from 'react-hook-form';
import { CreateJobDto } from '../../../../../../services/applicant_tracking/JobService/CreateJobDto';
import { SetupPageFooter } from '../../../../../../components/SetupPageFooter';
import { JobDetails } from '../../../../../../services/applicant_tracking/JobService/EditJobDto';
import {
  SetupHeaderButtonType,
  SetupPageHeader,
} from '../../../../../../components/SetupPageHeader';
import { buildJobWizardSaveActions } from '../../jobWizardSaveActions';

interface PropTypes {
  formState: FormState<CreateJobDto>;
  jobDetails: JobDetails;
  onCancel: () => void;
  onSave: () => void;
  onSaveAndContinue: () => void;
  onNext: () => void;
  isEditFlow: boolean;
  isLoading: boolean;
  isSaving: boolean;
  children: React.ReactNode;
}

export function JobDetailsLayout(props: PropTypes) {
  const isLoadingOrFormInvalid =
    props.isLoading || props.isSaving || !props.formState.isValid;

  const { headerSaveSlot, footerSaveSlot } = buildJobWizardSaveActions({
    jobDetails: props.jobDetails,
    isEditFlow: props.isEditFlow,
    disabled: isLoadingOrFormInvalid,
    isLoading: props.isSaving,
    onSaveAndContinue: props.onSaveAndContinue,
    onSaveAsDraft: props.onSave,
  });

  const nextButton: SetupHeaderButtonType = {
    title: 'Next',
    type: 'Navigate',
    action: props.onNext,
    disabled: isLoadingOrFormInvalid,
  };

  return (
    <>
      <SetupPageHeader
        title='Job Details'
        firstItems={props.isEditFlow ? [nextButton] : []}
        intermediateItems={[
          {
            title: 'Cancel',
            type: 'Cancel',
            action: props.onCancel,
          },
        ]}
        {...headerSaveSlot}
      />
      {props.children}
      {!props.isLoading && (
        <SetupPageFooter classNames='mt-4' {...footerSaveSlot} />
      )}
    </>
  );
}
